import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { payloadList } from "../../store/agent/transactions";
import {withdrawalSliceState} from "../../store/cashier/withdrawal";

const getList = (data: payloadList)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.cashier.withdrawal.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setDecline = (data: { id: string }) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.cashier.withdrawal.decline.replace('{id}', data.id);

  const payload = {
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const setApprove = (data: { id: string }) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.cashier.withdrawal.approve.replace('{id}', data.id);

  const payload = {
    authenticity_token: authenticity_token,
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};
export const withdrawalService = {
  getList,
  setDecline,
  setApprove,
};
